import React, { MouseEvent, useMemo } from 'react';

import styles from './Button.module.scss';
import { Icon as ArkIcon } from '../icon/Icon';
import { CaretDown, CaretSide } from '../icons';

interface CollapseButtonProps {
    onClick: (event: MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    fontSize?: number;
    testId?: string;
    isCollapsed: boolean;
}

export const CollapseButton: React.FC<CollapseButtonProps> = ({ onClick, disabled = false, fontSize, testId = '', isCollapsed }) => {
    const icon = useMemo(() => isCollapsed ? CaretSide : CaretDown, [isCollapsed]);
    return (
        <button
            onClick={onClick}
            className={styles.collapseButton}
            disabled={disabled}
            data-testid={`collapse-button-${testId}`}
        >
            <ArkIcon icon={icon} fontSize={fontSize} />
        </button>
    );
};
